module.exports = __webpack_public_path__ + "img/arrow-forward.ab2ae4b5.svg";